import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BookAdjustmentTabService {
  constructor(private http: HttpClient) {}

  getCodeCombination(baseUrl: string, combinationKey: number): Observable<any> {
    const urlParams = new URLSearchParams();
    urlParams.set('action_id', '9');
    urlParams.set('combination_key', combinationKey.toString());

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      baseUrl + '/loadJsonObject',
      urlParams.toString(),
      { headers, withCredentials: true }
    ).pipe(
      map(response => {
        if (response.errorMessage && response.errorMessage !== 'null') {
          throw new Error(response.errorMessage);
        }
        return response.jsonObject?.[0] || null;
      })
    );
  }

  getAccounts(baseUrl: string, params: any, globalService: any): Observable<any> {
    const urlParams = new URLSearchParams();
    urlParams.set('action_code', 'unmge8');

    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlParams.set(key, params[key].toString());
      }
    });

    if (globalService?.globalParams) {
      Object.keys(globalService.globalParams).forEach(key => {
        if (!urlParams.has(key)) {
          urlParams.set(key, globalService.globalParams[key]?.toString() || '');
        }
      });
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      baseUrl + '/loadJsonObject',
      urlParams.toString(),
      { headers, withCredentials: true }
    ).pipe(
      map(response => {
        if (response.errorMessage && response.errorMessage !== 'null') {
          throw new Error(response.errorMessage);
        }
        return response.jsonObject || [];
      })
    );
  }

  getTradingPartnersFir(baseUrl: string, taxYear: string, scenario: string, searchString: string, globalService: any): Observable<any> {
    const urlParams = new URLSearchParams();
    urlParams.set('action_code', '50swfi');
    urlParams.set('tax_year', taxYear || '');
    urlParams.set('scenario', scenario || '');
    urlParams.set('search_string', searchString || '');

    if (globalService?.globalParams) {
      Object.keys(globalService.globalParams).forEach(key => {
        if (!urlParams.has(key)) {
          urlParams.set(key, globalService.globalParams[key]?.toString() || '');
        }
      });
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      baseUrl + '/loadJsonObject',
      urlParams.toString(),
      { headers, withCredentials: true }
    ).pipe(
      map(response => {
        if (response.errorMessage && response.errorMessage !== 'null') {
          throw new Error(response.errorMessage);
        }
        return response.jsonObject || [];
      })
    );
  }

  getTradingPartnersDcs(baseUrl: string, taxYear: string, scenario: string, searchString: string, globalService: any): Observable<any> {
    const urlParams = new URLSearchParams();
    urlParams.set('action_code', 'sckfcq');
    urlParams.set('tax_year', taxYear || '');
    urlParams.set('scenario', scenario || '');
    urlParams.set('search_string', searchString || '');

    if (globalService?.globalParams) {
      Object.keys(globalService.globalParams).forEach(key => {
        if (!urlParams.has(key)) {
          urlParams.set(key, globalService.globalParams[key]?.toString() || '');
        }
      });
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      baseUrl + '/loadJsonObject',
      urlParams.toString(),
      { headers, withCredentials: true }
    ).pipe(
      map(response => {
        if (response.errorMessage && response.errorMessage !== 'null') {
          throw new Error(response.errorMessage);
        }
        return response.jsonObject || [];
      })
    );
  }

  getAmountsForDtlsAdj(baseUrl: string, combinationKey: number, accountKey: number, chartKey: number, tpKey: number, adjSource: string, globalService: any): Observable<any> {
    const urlParams = new URLSearchParams();
    urlParams.set('action_code', 'zf0obh');
    urlParams.set('combination_key', combinationKey.toString());
    urlParams.set('account_key', accountKey.toString());
    urlParams.set('chart_key', chartKey.toString());
    urlParams.set('tp_key', tpKey.toString());
    urlParams.set('adj_source', adjSource);

    if (globalService?.globalParams) {
      Object.keys(globalService.globalParams).forEach(key => {
        if (!urlParams.has(key)) {
          urlParams.set(key, globalService.globalParams[key]?.toString() || '');
        }
      });
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      baseUrl + '/loadJsonObject',
      urlParams.toString(),
      { headers, withCredentials: true }
    ).pipe(
      map(response => {
        if (response.errorMessage && response.errorMessage !== 'null') {
          throw new Error(response.errorMessage);
        }
        return response.jsonObject || [];
      })
    );
  }

  loadExistingReclass(baseUrl: string, screenKey: number, combinationKey: number, chartKey: number, accountKey: number, globalService: any): Observable<any> {
    const urlParams = new URLSearchParams();
    urlParams.set('action_code', 'clgdjl');
    urlParams.set('screen_key', screenKey.toString());
    urlParams.set('combination_key', combinationKey.toString());
    urlParams.set('chart_key', chartKey.toString());
    urlParams.set('account_key', accountKey.toString());

    if (globalService?.globalParams) {
      Object.keys(globalService.globalParams).forEach(key => {
        if (!urlParams.has(key)) {
          urlParams.set(key, globalService.globalParams[key]?.toString() || '');
        }
      });
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      baseUrl + '/loadJsonObject',
      urlParams.toString(),
      { headers, withCredentials: true }
    ).pipe(
      map(response => {
        if (response.errorMessage && response.errorMessage !== 'null') {
          throw new Error(response.errorMessage);
        }
        return response.jsonObject || [];
      })
    );
  }

  saveReclass(baseUrl: string, settings: any[], accounts: any[], globalService: any, filterParams: any): Observable<any> {
    const params: any = {
      ...(globalService?.globalParams || {}),
      ...(filterParams || {}),
      jsonObj: JSON.stringify(accounts),
      jsonSettings: JSON.stringify(settings),
      process_name: 'RECLASS_SAVE_LOCAL_ACCT'
    };

    const urlParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlParams.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      baseUrl + '/saveJsonObject?action_code=xqtzyo',
      urlParams.toString(),
      { headers, withCredentials: true }
    );
  }

  deleteReclass(baseUrl: string, headerData: any, deleteObj: any[], globalService: any, filterParams: any): Observable<any> {
    const params: any = {
      ...headerData,
      ...(globalService?.globalParams || {}),
      ...(filterParams || {}),
      jsonSettings: JSON.stringify([{ tax_year: filterParams?.tax_year }]),
      jsonObj: JSON.stringify(deleteObj)
    };

    const urlParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlParams.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      baseUrl + '/saveJsonObject?action_code=aemd60',
      urlParams.toString(),
      { headers, withCredentials: true }
    );
  }

  getStdReclassDescriptions(baseUrl: string, params: any, globalService: any): Observable<any> {
    const urlParams = new URLSearchParams();
    urlParams.set('action_code', 'akjjtr');
    Object.keys(params || {}).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlParams.set(key, params[key].toString());
      }
    });

    if (globalService?.globalParams) {
      Object.keys(globalService.globalParams).forEach(key => {
        if (!urlParams.has(key)) {
          urlParams.set(key, globalService.globalParams[key]?.toString() || '');
        }
      });
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      baseUrl + '/loadJsonObject',
      urlParams.toString(),
      { headers, withCredentials: true }
    ).pipe(
      map(response => {
        if (response.errorMessage && response.errorMessage !== 'null') {
          throw new Error(response.errorMessage);
        }
        return response.jsonObject || [];
      })
    );
  }

  getStdReclassComments(baseUrl: string, params: any, globalService: any): Observable<any> {
    const urlParams = new URLSearchParams();
    urlParams.set('action_code', 'jo8asp');
    Object.keys(params || {}).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlParams.set(key, params[key].toString());
      }
    });

    if (globalService?.globalParams) {
      Object.keys(globalService.globalParams).forEach(key => {
        if (!urlParams.has(key)) {
          urlParams.set(key, globalService.globalParams[key]?.toString() || '');
        }
      });
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      baseUrl + '/loadJsonObject',
      urlParams.toString(),
      { headers, withCredentials: true }
    ).pipe(
      map(response => {
        if (response.errorMessage && response.errorMessage !== 'null') {
          throw new Error(response.errorMessage);
        }
        return response.jsonObject || [];
      })
    );
  }

  getBookAmtByTp(baseUrl: string, screenKey: number, combinationKey: number, chartKey: number, sourceType: string, searchType: string, searchString: string, globalService: any): Observable<any> {
    const urlParams = new URLSearchParams();
    urlParams.set('action_code', 'unmge8');
    urlParams.set('screen_key', screenKey.toString());
    urlParams.set('combination_key', combinationKey.toString());
    urlParams.set('chart_key', chartKey.toString());
    urlParams.set('source_type', sourceType);
    urlParams.set('search_type', searchType);
    urlParams.set('search_string', searchString);

    if (globalService?.globalParams) {
      Object.keys(globalService.globalParams).forEach(key => {
        if (!urlParams.has(key)) {
          urlParams.set(key, globalService.globalParams[key]?.toString() || '');
        }
      });
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(
      baseUrl + '/loadJsonObject',
      urlParams.toString(),
      { headers, withCredentials: true }
    ).pipe(
      map(response => {
        if (response.errorMessage && response.errorMessage !== 'null') {
          throw new Error(response.errorMessage);
        }
        return response.jsonObject || [];
      })
    );
  }
}

